// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../img/bg_img.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SubscriptionExpired_container__\\+HJTD {
  display: flex;
  flex-direction: column;
  background-color: var(--color-light);
  align-items: center;
  width: 100vw;
  height: 100vh;
  padding: 3rem 8rem;
}
@media only screen and (max-width: 43.75em) {
  .SubscriptionExpired_container__\\+HJTD {
    padding: 3rem;
  }
}
.SubscriptionExpired_container__\\+HJTD > :first-child {
  align-self: stretch;
}

.SubscriptionExpired_topside__nR5h7 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}
.SubscriptionExpired_topside_1__aB3bm {
  display: flex;
  align-items: center;
}
.SubscriptionExpired_topside_1__aB3bm > :not(:last-child) {
  margin-right: 3rem;
}
.SubscriptionExpired_topside_welcome__10lQm {
  font-size: var(--default-font-small);
  line-height: 1.8rem;
}
.SubscriptionExpired_topside_name__X-jR\\+ {
  color: var(--color-primary);
  font-size: var(--default-font-subtitle);
  font-weight: 700;
  line-height: 3rem;
}
.SubscriptionExpired_topside_icon__nWexB {
  display: flex;
  align-items: center;
}
@media only screen and (max-width: 31.25em) {
  .SubscriptionExpired_topside_icon__nWexB {
    margin-bottom: 1rem;
  }
}
.SubscriptionExpired_topside_icon_main__BiLPO {
  display: flex;
  align-items: center;
}
@media only screen and (max-width: 31.25em) {
  .SubscriptionExpired_topside_icon_main__BiLPO {
    flex-direction: column-reverse;
  }
}

.SubscriptionExpired_banner__DQ99A {
  display: grid;
  grid-template-columns: 1fr 40%;
  gap: 2rem;
  padding: 2rem;
  align-items: center;
  width: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  box-sizing: border-box;
}
@media only screen and (max-width: 62.5em) {
  .SubscriptionExpired_banner__DQ99A {
    grid-template-columns: 40% 1fr;
  }
}
@media only screen and (max-width: 50em) {
  .SubscriptionExpired_banner__DQ99A {
    grid-template-columns: 1fr;
  }
}
.SubscriptionExpired_banner__walletBg__bzoD4 {
  display: flex;
  width: 100%;
  justify-content: space-between;
  background-color: var(--color-white);
  box-sizing: border-box;
  padding: 2rem;
}

.SubscriptionExpired_balance__side__78beZ {
  display: flex;
  justify-content: space-between;
}
.SubscriptionExpired_balance__amount__nj\\+ea {
  display: flex;
  flex-direction: column;
}
.SubscriptionExpired_balance__btns__EQJow {
  padding-left: 1rem;
}

.SubscriptionExpired_selectCurrency__96tBH {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: var(--default-font-small);
  position: relative;
  margin-left: 2rem;
}
.SubscriptionExpired_selectCurrency__text__c9YWe {
  display: flex;
  margin-left: 1rem;
}
.SubscriptionExpired_selectCurrency__icon__I10e7 {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
  background-color: #f2f0f0;
  color: var(--color-primary);
  width: 3rem;
  height: 3rem;
  border-radius: 5rem;
  border: solid 1px var(--color-primary-4);
  cursor: pointer;
  transform: rotateZ(0);
  transition-duration: 500ms;
}
.SubscriptionExpired_selectCurrency__icon__I10e7:hover {
  box-shadow: 10px 10px 45px #bebebe, -15px -15px 30px #ffffff;
  background-color: var(--color-primary-3);
  transform: rotateZ(-180deg);
}
.SubscriptionExpired_selectCurrency__icon_active__HjAkP {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
  background-color: #f2f0f0;
  color: var(--color-primary);
  width: 3rem;
  height: 3rem;
  border-radius: 5rem;
  border: solid 1px var(--color-primary-4);
  cursor: pointer;
  transition-duration: 500ms;
  box-shadow: 10px 10px 45px #bebebe, -15px -15px 30px #ffffff;
  background-color: var(--color-primary-3);
  transform: rotateZ(-180deg);
}
.SubscriptionExpired_selectCurrency__list__C85li {
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  width: 5rem;
  background-color: #f2f0f0;
  color: var(--color-dark);
  border-radius: 1rem;
  box-shadow: 10px 10px 45px #bebebe, -15px -15px 30px #ffffff;
  position: absolute;
  top: 6rem;
  z-index: 30;
  border: solid 1px var(--color-primary-4);
}
.SubscriptionExpired_selectCurrency__list_active__MRDCj {
  background-color: var(--color-primary-7);
  color: var(--color-primary);
  font-weight: 700;
}
.SubscriptionExpired_selectCurrency__list__C85li li {
  list-style: none;
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 1rem 0;
  box-sizing: border-box;
  border-radius: 1rem;
  cursor: pointer;
}
.SubscriptionExpired_selectCurrency__list__C85li li:hover {
  background-color: var(--color-primary-7);
  color: var(--color-primary);
  font-weight: 700;
}

.SubscriptionExpired_subImg__krqT5 {
  width: 28rem;
  margin: 4rem 0;
}

.SubscriptionExpired_logo__oDAGA {
  height: 3.8rem;
  margin-bottom: 3rem;
}

.SubscriptionExpired_btns__usJaN {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 3rem;
  padding-bottom: 4rem;
}
@media only screen and (max-width: 56.25em) {
  .SubscriptionExpired_btns__usJaN {
    grid-template-columns: 1fr;
    gap: 3rem;
  }
}
.SubscriptionExpired_btns__btn__5bwwa {
  display: flex;
  flex-direction: column;
  background-color: var(--color-white);
  border: 1px solid var(--color-primary);
  border-radius: 0.8rem;
  padding: 3rem;
  width: 35rem;
  cursor: pointer;
  transition: all 0.2s;
}
@media only screen and (max-width: 56.25em) {
  .SubscriptionExpired_btns__btn__5bwwa {
    width: 38rem;
  }
}
.SubscriptionExpired_btns__btn__5bwwa:hover {
  background-color: var(--color-primary-3);
  border: 2px solid var(--color-primary);
  color: var(--color-primary);
  font-weight: 700;
  transition: all 0.2s;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Onboarding/SubscriptionExpired.module.scss"],"names":[],"mappings":"AAEA;EACC,aAAA;EACA,sBAAA;EACA,oCAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AADD;AAGC;EATD;IAUE,aAAA;EAAA;AACF;AAEC;EACC,mBAAA;AAAF;;AAIA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AADD;AAGC;EACC,aAAA;EACA,mBAAA;AADF;AAGE;EACC,kBAAA;AADH;AAKC;EACC,oCAAA;EACA,mBAAA;AAHF;AAMC;EACC,2BAAA;EACA,uCAAA;EACA,gBAAA;EACA,iBAAA;AAJF;AAOC;EACC,aAAA;EACA,mBAAA;AALF;AAOE;EAJD;IAKE,mBAAA;EAJD;AACF;AAME;EACC,aAAA;EACA,mBAAA;AAJH;AAMG;EAJD;IAKE,8BAAA;EAHF;AACF;;AAQA;EACC,aAAA;EACA,8BAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,yDAAA;EACA,sBAAA;EACA,sBAAA;AALD;AAOC;EAXD;IAYE,8BAAA;EAJA;AACF;AAMC;EAfD;IAgBE,0BAAA;EAHA;AACF;AAKC;EACC,aAAA;EACA,WAAA;EACA,8BAAA;EACA,oCAAA;EACA,sBAAA;EACA,aAAA;AAHF;;AAQC;EACC,aAAA;EACA,8BAAA;AALF;AAQC;EACC,aAAA;EACA,sBAAA;AANF;AASC;EACC,kBAAA;AAPF;;AAWA;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,oCAAA;EACA,kBAAA;EACA,iBAAA;AARD;AAUC;EACC,aAAA;EACA,iBAAA;AARF;AAWC;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wCAAA;EACA,eAAA;EACA,qBAAA;EACA,0BAAA;AATF;AAWE;EACC,4DACC;EAED,wCAAA;EACA,2BAAA;AAXH;AAcE;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,2BAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,wCAAA;EACA,eAAA;EACA,0BAAA;EACA,4DACC;EAED,wCAAA;EACA,2BAAA;AAdH;AAkBC;EACC,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,yBAAA;EACA,wBAAA;EACA,mBAAA;EACA,4DACC;EAED,kBAAA;EACA,SAAA;EACA,WAAA;EACA,wCAAA;AAlBF;AAoBE;EACC,wCAAA;EACA,2BAAA;EACA,gBAAA;AAlBH;AAqBE;EACC,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AAnBH;AAqBG;EACC,wCAAA;EACA,2BAAA;EACA,gBAAA;AAnBJ;;AAyBA;EACC,YAAA;EACA,cAAA;AAtBD;;AAyBA;EACC,cAAA;EACA,mBAAA;AAtBD;;AAyBA;EACC,aAAA;EACA,qCAAA;EACA,SAAA;EACA,oBAAA;AAtBD;AAwBC;EAND;IAOE,0BAAA;IACA,SAAA;EArBA;AACF;AAuBC;EACC,aAAA;EACA,sBAAA;EACA,oCAAA;EACA,sCAAA;EACA,qBAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;AArBF;AAsBE;EAVD;IAWE,YAAA;EAnBD;AACF;AAqBE;EACC,wCAAA;EACA,sCAAA;EACA,2BAAA;EACA,gBAAA;EACA,oBAAA;AAnBH","sourcesContent":["@import '../variables/breakpoints';\n\n.container {\n\tdisplay: flex;\n\tflex-direction: column;\n\tbackground-color: var(--color-light);\n\talign-items: center;\n\twidth: 100vw;\n\theight: 100vh;\n\tpadding: 3rem 8rem;\n\n\t@media only screen and (max-width: $bp-700) {\n\t\tpadding: 3rem;\n\t}\n\n\t& > :first-child {\n\t\talign-self: stretch;\n\t}\n}\n\n.topside {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tmargin-bottom: 2rem;\n\n\t&_1 {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\n\t\t& > :not(:last-child) {\n\t\t\tmargin-right: 3rem;\n\t\t}\n\t}\n\n\t&_welcome {\n\t\tfont-size: var(--default-font-small);\n\t\tline-height: 1.8rem;\n\t}\n\n\t&_name {\n\t\tcolor: var(--color-primary);\n\t\tfont-size: var(--default-font-subtitle);\n\t\tfont-weight: 700;\n\t\tline-height: 3rem;\n\t}\n\n\t&_icon {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\n\t\t@media only screen and (max-width: $bp-500) {\n\t\t\tmargin-bottom: 1rem;\n\t\t}\n\n\t\t&_main {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\n\t\t\t@media only screen and (max-width: $bp-500) {\n\t\t\t\tflex-direction: column-reverse;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.banner {\n\tdisplay: grid;\n\tgrid-template-columns: 1fr 40%;\n\tgap: 2rem;\n\tpadding: 2rem;\n\talign-items: center;\n\twidth: 100%;\n\tbackground-image: url('../../img/bg_img.svg');\n\tbackground-size: cover;\n\tbox-sizing: border-box;\n\n\t@media only screen and (max-width: $bp-1000) {\n\t\tgrid-template-columns: 40% 1fr;\n\t}\n\n\t@media only screen and (max-width: $bp-800) {\n\t\tgrid-template-columns: 1fr;\n\t}\n\n\t&__walletBg {\n\t\tdisplay: flex;\n\t\twidth: 100%;\n\t\tjustify-content: space-between;\n\t\tbackground-color: var(--color-white);\n\t\tbox-sizing: border-box;\n\t\tpadding: 2rem;\n\t}\n}\n\n.balance {\n\t&__side {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t}\n\n\t&__amount {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t}\n\n\t&__btns {\n\t\tpadding-left: 1rem;\n\t}\n}\n\n.selectCurrency {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tfont-size: var(--default-font-small);\n\tposition: relative;\n\tmargin-left: 2rem;\n\n\t&__text {\n\t\tdisplay: flex;\n\t\tmargin-left: 1rem;\n\t}\n\n\t&__icon {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tfont-size: 3rem;\n\t\tbackground-color: #f2f0f0;\n\t\tcolor: var(--color-primary);\n\t\twidth: 3rem;\n\t\theight: 3rem;\n\t\tborder-radius: 5rem;\n\t\tborder: solid 1px var(--color-primary-4);\n\t\tcursor: pointer;\n\t\ttransform: rotateZ(0);\n\t\ttransition-duration: 500ms;\n\n\t\t&:hover {\n\t\t\tbox-shadow:\n\t\t\t\t10px 10px 45px #bebebe,\n\t\t\t\t-15px -15px 30px #ffffff;\n\t\t\tbackground-color: var(--color-primary-3);\n\t\t\ttransform: rotateZ(-180deg);\n\t\t}\n\n\t\t&_active {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\talign-items: center;\n\t\t\tfont-size: 3rem;\n\t\t\tbackground-color: #f2f0f0;\n\t\t\tcolor: var(--color-primary);\n\t\t\twidth: 3rem;\n\t\t\theight: 3rem;\n\t\t\tborder-radius: 5rem;\n\t\t\tborder: solid 1px var(--color-primary-4);\n\t\t\tcursor: pointer;\n\t\t\ttransition-duration: 500ms;\n\t\t\tbox-shadow:\n\t\t\t\t10px 10px 45px #bebebe,\n\t\t\t\t-15px -15px 30px #ffffff;\n\t\t\tbackground-color: var(--color-primary-3);\n\t\t\ttransform: rotateZ(-180deg);\n\t\t}\n\t}\n\n\t&__list {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tbox-sizing: border-box;\n\t\twidth: 5rem;\n\t\tbackground-color: #f2f0f0;\n\t\tcolor: var(--color-dark);\n\t\tborder-radius: 1rem;\n\t\tbox-shadow:\n\t\t\t10px 10px 45px #bebebe,\n\t\t\t-15px -15px 30px #ffffff;\n\t\tposition: absolute;\n\t\ttop: 6rem;\n\t\tz-index: 30;\n\t\tborder: solid 1px var(--color-primary-4);\n\n\t\t&_active {\n\t\t\tbackground-color: var(--color-primary-7);\n\t\t\tcolor: var(--color-primary);\n\t\t\tfont-weight: 700;\n\t\t}\n\n\t\tli {\n\t\t\tlist-style: none;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: center;\n\t\t\twidth: 100%;\n\t\t\tpadding: 1rem 0;\n\t\t\tbox-sizing: border-box;\n\t\t\tborder-radius: 1rem;\n\t\t\tcursor: pointer;\n\n\t\t\t&:hover {\n\t\t\t\tbackground-color: var(--color-primary-7);\n\t\t\t\tcolor: var(--color-primary);\n\t\t\t\tfont-weight: 700;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.subImg {\n\twidth: 28rem;\n\tmargin: 4rem 0;\n}\n\n.logo {\n\theight: 3.8rem;\n\tmargin-bottom: 3rem;\n}\n\n.btns {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(3, 1fr);\n\tgap: 3rem;\n\tpadding-bottom: 4rem;\n\n\t@media only screen and (max-width: $bp-900) {\n\t\tgrid-template-columns: 1fr;\n\t\tgap: 3rem;\n\t}\n\n\t&__btn {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tbackground-color: var(--color-white);\n\t\tborder: 1px solid var(--color-primary);\n\t\tborder-radius: 0.8rem;\n\t\tpadding: 3rem;\n\t\twidth: 35rem;\n\t\tcursor: pointer;\n\t\ttransition: all 0.2s;\n\t\t@media only screen and (max-width: $bp-900) {\n\t\t\twidth: 38rem;\n\t\t}\n\n\t\t&:hover {\n\t\t\tbackground-color: var(--color-primary-3);\n\t\t\tborder: 2px solid var(--color-primary);\n\t\t\tcolor: var(--color-primary);\n\t\t\tfont-weight: 700;\n\t\t\ttransition: all 0.2s;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SubscriptionExpired_container__+HJTD`,
	"topside": `SubscriptionExpired_topside__nR5h7`,
	"topside_1": `SubscriptionExpired_topside_1__aB3bm`,
	"topside_welcome": `SubscriptionExpired_topside_welcome__10lQm`,
	"topside_name": `SubscriptionExpired_topside_name__X-jR+`,
	"topside_icon": `SubscriptionExpired_topside_icon__nWexB`,
	"topside_icon_main": `SubscriptionExpired_topside_icon_main__BiLPO`,
	"banner": `SubscriptionExpired_banner__DQ99A`,
	"banner__walletBg": `SubscriptionExpired_banner__walletBg__bzoD4`,
	"balance__side": `SubscriptionExpired_balance__side__78beZ`,
	"balance__amount": `SubscriptionExpired_balance__amount__nj+ea`,
	"balance__btns": `SubscriptionExpired_balance__btns__EQJow`,
	"selectCurrency": `SubscriptionExpired_selectCurrency__96tBH`,
	"selectCurrency__text": `SubscriptionExpired_selectCurrency__text__c9YWe`,
	"selectCurrency__icon": `SubscriptionExpired_selectCurrency__icon__I10e7`,
	"selectCurrency__icon_active": `SubscriptionExpired_selectCurrency__icon_active__HjAkP`,
	"selectCurrency__list": `SubscriptionExpired_selectCurrency__list__C85li`,
	"selectCurrency__list_active": `SubscriptionExpired_selectCurrency__list_active__MRDCj`,
	"subImg": `SubscriptionExpired_subImg__krqT5`,
	"logo": `SubscriptionExpired_logo__oDAGA`,
	"btns": `SubscriptionExpired_btns__usJaN`,
	"btns__btn": `SubscriptionExpired_btns__btn__5bwwa`
};
export default ___CSS_LOADER_EXPORT___;
